import { http } from "@/config/http";

const namespaced = true;

const getDefaultState = () => {
  return {
    familyInfoData: {
      drpFamilyInfoMaritalStatus: "Unmarried",
      rdbSpouse: "No",
      rdbChildren: 0,
      rdbChildrenPrev: "New"
    },
    mainInfoData: {
      drpMainLifetitle: "Please select",
      txtMainLifeFname: "",
      txtMainLifeMname: "",
      txtMainLifeLname: "",
      txtMainLifeNIC: "",
      txtMainLifeMob: "",
      txtMainLifeEmail: "",
      txtMainLifeAge: "",
      rdbMainGender: "Male",
      txtMainLifeDOB: "2000-01-01",
      drpMainLifePrimaryNeed: "Savings",
      txtMainLifeMonthlyBasicPrem: 5000,
      txtMainLifePolicyTerm: 15,
      drpMainLifeContributionTerm: 9,
      txtMainLifePremiumTerm: 5,
      rdbMainLifeFrequency: "M",
      // drpMainLifeOccupation: {
      //   code: "OEX0157",
      //   label: "Teachers"
      // },
      drpMainLifeOccupation:"",
      txtMainSumAtRisk: 0,
      txtNumOfSumAsTimes: 10,
      mainAge: 0,
      rdbMainMedrem3Floater: "No",
      txtMainLifeSumCover: 0,
      drpMainLifeCoverMultiple: 0.1,

    },
    spouseInfoData: {
      drpSpouseTitle: "Please select",
      txtSpouseFname: "",
      txtSpouseMname: "",
      txtSpouseLname: "",
      rdbSpouseGender: "Female",
      txtSpouseDOB: "2000-01-01",
      // drpSpouseOccupation: {
      //   code: "OEX0157",
      //   label: "Teachers"
      // },
      drpSpouseOccupation:"",
      txtSpouseSumAtRisk: 0,
      txtSpouseAge: 0
    },
    calcSummary: { summary: 0 },
    childInfoData: [],
    riderDataMain: [],
    riderDataSpouse: [],
    riderDataChildren: [],
    quotationList: [],
    occupationList: [],
    hospitalList: [],
    occupationLoadingList: [],
    drpQuoteListHospital: {
      code: "UHC001",
      label: "AROGYA HOSPITALS LTD (PVT) LTD - GAMPAHA"
    },
    flash: {
      type: "W",
      status: false,
      error: ""
    },
    timestamp: "",
    minflash: {
      status: false,
      error: ""
    },
    quotationNo: "",
    version: "",
    refNo: "",
    availableCoverAmounts:[
      500000,1000000,2000000,2100000,2200000,2300000,2400000,2500000,2600000,2700000,2800000,2900000,3000000,3100000,3200000,3300000,3400000,3500000,3600000,3700000,3800000,3900000,4000000,4100000,4200000,4300000,4400000,4500000,4600000,4700000,4800000,4900000,5000000,5100000,5200000,5300000,5400000,5500000,5600000,5700000,5800000,5900000,6000000,6100000,6200000,6300000,6400000,6500000,6600000,6700000,6800000,6900000,7000000,7100000,7200000,7300000,7400000,7500000,7600000,7700000,7800000,7900000,8000000,8100000,8200000,8300000,8400000,8500000,8600000,8700000,8800000,8900000,9000000,9100000,9200000,9300000,9400000,9500000,9600000,9700000,9800000,9900000,10000000,10100000,10200000,10300000,10400000,10500000,10600000,10700000,10800000,10900000,11000000,11100000,11200000,11300000,11400000,11500000,11600000,11700000,11800000,11900000,12000000,12100000,12200000,12300000,12400000,12500000,12600000,12700000,12800000,12900000,13000000,13100000,13200000,13300000,13400000,13500000,13600000,13700000,13800000,13900000,14000000,14100000,14200000,14300000,14400000,14500000,14600000,14700000,14800000,14900000,15000000,15100000,15200000,15300000,15400000,15500000,15600000,15700000,15800000,15900000,16000000,16100000,16200000,16300000,16400000,16500000,16600000,16700000,16800000,16900000,17000000,17100000,17200000,17300000,17400000,17500000,17600000,17700000,17800000,17900000,18000000,18100000,18200000,18300000,18400000,18500000,18600000,18700000,18800000,18900000,19000000,19100000,19200000,19300000,19400000,19500000,19600000,19700000,19800000,19900000,20000000,20100000,20200000,20300000,20400000,20500000,20600000,20700000,20800000,20900000,21000000,21100000,21200000,21300000,21400000,21500000,21600000,21700000,21800000,21900000,22000000,22100000,22200000,22300000,22400000,22500000,22600000,22700000,22800000,22900000,23000000,23100000,23200000,23300000,23400000,23500000,23600000,23700000,23800000,23900000,24000000,24100000,24200000,24300000,24400000,24500000,24600000,24700000,24800000,24900000,25000000,25100000,25200000,25300000,25400000,25500000,25600000,25700000,25800000,25900000,26000000,26100000,26200000,26300000,26400000,26500000,26600000,26700000,26800000,26900000,27000000,27100000,27200000,27300000,27400000,27500000,27600000,27700000,27800000,27900000,28000000,28100000,28200000,28300000,28400000,28500000,28600000,28700000,28800000,28900000,29000000,29100000,29200000,29300000,29400000,29500000,29600000,29700000,29800000,29900000,30000000,30100000,30200000,30300000,30400000,30500000,30600000,30700000,30800000,30900000,31000000,31100000,31200000,31300000,31400000,31500000,31600000,31700000,31800000,31900000,32000000,32100000,32200000,32300000,32400000,32500000,32600000,32700000,32800000,32900000,33000000,33100000,33200000,33300000,33400000,33500000,33600000,33700000,33800000,33900000,34000000,34100000,34200000,34300000,34400000,34500000,34600000,34700000,34800000,34900000,35000000,35100000,35200000,35300000,35400000,35500000,35600000,35700000,35800000,35900000,36000000,36100000,36200000,36300000,36400000,36500000,36600000,36700000,36800000,36900000,37000000,37100000,37200000,37300000,37400000,37500000,37600000,37700000,37800000,37900000,38000000,38100000,38200000,38300000,38400000,38500000,38600000,38700000,38800000,38900000,39000000,39100000,39200000,39300000,39400000,39500000,39600000,39700000,39800000,39900000,40000000,40100000,40200000,40300000,40400000,40500000,40600000,40700000,40800000,40900000,41000000,41100000,41200000,41300000,41400000,41500000,41600000,41700000,41800000,41900000,42000000,42100000,42200000,42300000,42400000,42500000,42600000,42700000,42800000,42900000,43000000,43100000,43200000,43300000,43400000,43500000,43600000,43700000,43800000,43900000,44000000,44100000,44200000,44300000,44400000,44500000,44600000,44700000,44800000,44900000,45000000,45100000,45200000,45300000,45400000,45500000,45600000,45700000,45800000,45900000,46000000,46100000,46200000,46300000,46400000,46500000,46600000,46700000,46800000,46900000,47000000,47100000,47200000,47300000,47400000,47500000,47600000,47700000,47800000,47900000,48000000,48100000,48200000,48300000,48400000,48500000,48600000,48700000,48800000,48900000,49000000,49100000,49200000,49300000,49400000,49500000,49600000,49700000,49800000,49900000,50000000,50100000,50200000,50300000,50400000,50500000,50600000,50700000,50800000,50900000,51000000,51100000,51200000,51300000,51400000,51500000,51600000,51700000,51800000,51900000,52000000,52100000,52200000,52300000,52400000,52500000,52600000,52700000,52800000,52900000,53000000,53100000,53200000,53300000,53400000,53500000,53600000,53700000,53800000,53900000,54000000,54100000,54200000,54300000,54400000,54500000,54600000,54700000,54800000,54900000,55000000,55100000,55200000,55300000,55400000,55500000,55600000,55700000,55800000,55900000,56000000,56100000,56200000,56300000,56400000,56500000,56600000,56700000,56800000,56900000,57000000,57100000,57200000,57300000,57400000,57500000,57600000,57700000,57800000,57900000,58000000,58100000,58200000,58300000,58400000,58500000,58600000,58700000,58800000,58900000,59000000,59100000,59200000,59300000,59400000,59500000,59600000,59700000,59800000,59900000,60000000,60100000,60200000,60300000,60400000,60500000,60600000,60700000,60800000,60900000,61000000,61100000,61200000,61300000,61400000,61500000,61600000,61700000,61800000,61900000,62000000,62100000,62200000,62300000,62400000,62500000,62600000,62700000,62800000,62900000,63000000,63100000,63200000,63300000,63400000,63500000,63600000,63700000,63800000,63900000,64000000,64100000,64200000,64300000,64400000,64500000,64600000,64700000,64800000,64900000,65000000,65100000,65200000,65300000,65400000,65500000,65600000,65700000,65800000,65900000,66000000,66100000,66200000,66300000,66400000,66500000,66600000,66700000,66800000,66900000,67000000,67100000,67200000,67300000,67400000,67500000,67600000,67700000,67800000,67900000,68000000,68100000,68200000,68300000,68400000,68500000,68600000,68700000,68800000,68900000,69000000,69100000,69200000,69300000,69400000,69500000,69600000,69700000,69800000,69900000,70000000,70100000,70200000,70300000,70400000,70500000,70600000,70700000,70800000,70900000,71000000,71100000,71200000,71300000,71400000,71500000,71600000,71700000,71800000,71900000,72000000,72100000,72200000,72300000,72400000,72500000,72600000,72700000,72800000,72900000,73000000,73100000,73200000,73300000,73400000,73500000,73600000,73700000,73800000,73900000,74000000,74100000,74200000,74300000,74400000,74500000,74600000,74700000,74800000,74900000,75000000,75100000,75200000,75300000,75400000,75500000,75600000,75700000,75800000,75900000,76000000,76100000,76200000,76300000,76400000,76500000,76600000,76700000,76800000,76900000,77000000,77100000,77200000,77300000,77400000,77500000,77600000,77700000,77800000,77900000,78000000,78100000,78200000,78300000,78400000,78500000,78600000,78700000,78800000,78900000,79000000,79100000,79200000,79300000,79400000,79500000,79600000,79700000,79800000,79900000,80000000,80100000,80200000,80300000,80400000,80500000,80600000,80700000,80800000,80900000,81000000,81100000,81200000,81300000,81400000,81500000,81600000,81700000,81800000,81900000,82000000,82100000,82200000,82300000,82400000,82500000,82600000,82700000,82800000,82900000,83000000,83100000,83200000,83300000,83400000,83500000,83600000,83700000,83800000,83900000,84000000,84100000,84200000,84300000,84400000,84500000,84600000,84700000,84800000,84900000,85000000,85100000,85200000,85300000,85400000,85500000,85600000,85700000,85800000,85900000,86000000,86100000,86200000,86300000,86400000,86500000,86600000,86700000,86800000,86900000,87000000,87100000,87200000,87300000,87400000,87500000,87600000,87700000,87800000,87900000,88000000,88100000,88200000,88300000,88400000,88500000,88600000,88700000,88800000,88900000,89000000,89100000,89200000,89300000,89400000,89500000,89600000,89700000,89800000,89900000,90000000,90100000,90200000,90300000,90400000,90500000,90600000,90700000,90800000,90900000,91000000,91100000,91200000,91300000,91400000,91500000,91600000,91700000,91800000,91900000,92000000,92100000,92200000,92300000,92400000,92500000,92600000,92700000,92800000,92900000,93000000,93100000,93200000,93300000,93400000,93500000,93600000,93700000,93800000,93900000,94000000,94100000,94200000,94300000,94400000,94500000,94600000,94700000,94800000,94900000,95000000,95100000,95200000,95300000,95400000,95500000,95600000,95700000,95800000,95900000,96000000,96100000,96200000,96300000,96400000,96500000,96600000,96700000,96800000,96900000,97000000,97100000,97200000,97300000,97400000,97500000,97600000,97700000,97800000,97900000,98000000,98100000,98200000,98300000,98400000,98500000,98600000,98700000,98800000,98900000,99000000,99100000,99200000,99300000,99400000,99500000,99600000,99700000,99800000,99900000,100000000,100100000,100200000,100300000,100400000,100500000,100600000,100700000,100800000,100900000,101000000,101100000,101200000,101300000,101400000,101500000,101600000,101700000,101800000,101900000,102000000,102100000,102200000,102300000,102400000,102500000,102600000,102700000,102800000,102900000,103000000,103100000,103200000,103300000,103400000,103500000,103600000,103700000,103800000,103900000,104000000,104100000,104200000,104300000,104400000,104500000,104600000,104700000,104800000,104900000,105000000,105100000,105200000,105300000,105400000,105500000,105600000,105700000,105800000,105900000,106000000,106100000,106200000,106300000,106400000,106500000,106600000,106700000,106800000,106900000,107000000,107100000,107200000,107300000,107400000,107500000,107600000,107700000,107800000,107900000,108000000,108100000,108200000,108300000,108400000,108500000,108600000,108700000,108800000,108900000,109000000,109100000,109200000,109300000,109400000,109500000,109600000,109700000,109800000,109900000,110000000,110100000,110200000,110300000,110400000,110500000,110600000,110700000,110800000,110900000,111000000,111100000,111200000,111300000,111400000,111500000,111600000,111700000,111800000,111900000,112000000,112100000,112200000,112300000,112400000,112500000,112600000,112700000,112800000,112900000,113000000,113100000,113200000,113300000,113400000,113500000,113600000,113700000,113800000,113900000,114000000,114100000,114200000,114300000,114400000,114500000,114600000,114700000,114800000,114900000,115000000,115100000,115200000,115300000,115400000,115500000,115600000,115700000,115800000,115900000,116000000,116100000,116200000,116300000,116400000,116500000,116600000,116700000,116800000,116900000,117000000,117100000,117200000,117300000,117400000,117500000,117600000,117700000,117800000,117900000,118000000,118100000,118200000,118300000,118400000,118500000,118600000,118700000,118800000,118900000,119000000,119100000,119200000,119300000,119400000,119500000,119600000,119700000,119800000,119900000,120000000,120100000,120200000,120300000,120400000,120500000,120600000,120700000,120800000,120900000,121000000,121100000,121200000,121300000,121400000,121500000,121600000,121700000,121800000,121900000,122000000,122100000,122200000,122300000,122400000,122500000,122600000,122700000,122800000,122900000,123000000,123100000,123200000,123300000,123400000,123500000,123600000,123700000,123800000,123900000,124000000,124100000,124200000,124300000,124400000,124500000,124600000,124700000,124800000,124900000,125000000,125100000,125200000,125300000,125400000,125500000,125600000,125700000,125800000,125900000,126000000,126100000,126200000,126300000,126400000,126500000,126600000,126700000,126800000,126900000,127000000,127100000,127200000,127300000,127400000,127500000,127600000,127700000,127800000,127900000,128000000,128100000,128200000,128300000,128400000,128500000,128600000,128700000,128800000,128900000,129000000,129100000,129200000,129300000,129400000,129500000,129600000,129700000,129800000,129900000,130000000,130100000,130200000,130300000,130400000,130500000,130600000,130700000,130800000,130900000,131000000,131100000,131200000,131300000,131400000,131500000,131600000,131700000,131800000,131900000,132000000,132100000,132200000,132300000,132400000,132500000,132600000,132700000,132800000,132900000,133000000,133100000,133200000,133300000,133400000,133500000,133600000,133700000,133800000,133900000,134000000,134100000,134200000,134300000,134400000,134500000,134600000,134700000,134800000,134900000,135000000,135100000,135200000,135300000,135400000,135500000,135600000,135700000,135800000,135900000,136000000,136100000,136200000,136300000,136400000,136500000,136600000,136700000,136800000,136900000,137000000,137100000,137200000,137300000,137400000,137500000,137600000,137700000,137800000,137900000,138000000,138100000,138200000,138300000,138400000,138500000,138600000,138700000,138800000,138900000,139000000,139100000,139200000,139300000,139400000,139500000,139600000,139700000,139800000,139900000,140000000,140100000,140200000,140300000,140400000,140500000,140600000,140700000,140800000,140900000,141000000,141100000,141200000,141300000,141400000,141500000,141600000,141700000,141800000,141900000,142000000,142100000,142200000,142300000,142400000,142500000,142600000,142700000,142800000,142900000,143000000,143100000,143200000,143300000,143400000,143500000,143600000,143700000,143800000,143900000,144000000,144100000,144200000,144300000,144400000,144500000,144600000,144700000,144800000,144900000,145000000,145100000,145200000,145300000,145400000,145500000,145600000,145700000,145800000,145900000,146000000,146100000,146200000,146300000,146400000,146500000,146600000,146700000,146800000,146900000,147000000,147100000,147200000,147300000,147400000,147500000,147600000,147700000,147800000,147900000,148000000,148100000,148200000,148300000,148400000,148500000,148600000,148700000,148800000,148900000,149000000,149100000,149200000,149300000,149400000,149500000,149600000,149700000,149800000,149900000,150000000,150100000,150200000,150300000,150400000,150500000,150600000,150700000,150800000,150900000,151000000,151100000,151200000,151300000,151400000,151500000,151600000,151700000,151800000,151900000,152000000,152100000,152200000,152300000,152400000,152500000,152600000,152700000,152800000,152900000,153000000,153100000,153200000,153300000,153400000,153500000,153600000,153700000,153800000,153900000,154000000,154100000,154200000,154300000,154400000,154500000,154600000,154700000,154800000,154900000,155000000,155100000,155200000,155300000,155400000,155500000,155600000,155700000,155800000,155900000,156000000,156100000,156200000,156300000,156400000,156500000,156600000,156700000,156800000,156900000,157000000,157100000,157200000,157300000,157400000,157500000,157600000,157700000,157800000,157900000,158000000,158100000,158200000,158300000,158400000,158500000,158600000,158700000,158800000,158900000,159000000,159100000,159200000,159300000,159400000,159500000,159600000,159700000,159800000,159900000,160000000,160100000,160200000,160300000,160400000,160500000,160600000,160700000,160800000,160900000,161000000,161100000,161200000,161300000,161400000,161500000,161600000,161700000,161800000,161900000,162000000,162100000,162200000,162300000,162400000,162500000,162600000,162700000,162800000,162900000,163000000,163100000,163200000,163300000,163400000,163500000,163600000,163700000,163800000,163900000,164000000,164100000,164200000,164300000,164400000,164500000,164600000,164700000,164800000,164900000,165000000,165100000,165200000,165300000,165400000,165500000,165600000,165700000,165800000,165900000,166000000,166100000,166200000,166300000,166400000,166500000,166600000,166700000,166800000,166900000,167000000,167100000,167200000,167300000,167400000,167500000,167600000,167700000,167800000,167900000,168000000,168100000,168200000,168300000,168400000,168500000,168600000,168700000,168800000,168900000,169000000,169100000,169200000,169300000,169400000,169500000,169600000,169700000,169800000,169900000,170000000,170100000,170200000,170300000,170400000,170500000,170600000,170700000,170800000,170900000,171000000,171100000,171200000,171300000,171400000,171500000,171600000,171700000,171800000,171900000,172000000,172100000,172200000,172300000,172400000,172500000,172600000,172700000,172800000,172900000,173000000,173100000,173200000,173300000,173400000,173500000,173600000,173700000,173800000,173900000,174000000,174100000,174200000,174300000,174400000,174500000,174600000,174700000,174800000,174900000,175000000,175100000,175200000,175300000,175400000,175500000,175600000,175700000,175800000,175900000,176000000,176100000,176200000,176300000,176400000,176500000,176600000,176700000,176800000,176900000,177000000,177100000,177200000,177300000,177400000,177500000,177600000,177700000,177800000,177900000,178000000,178100000,178200000,178300000,178400000,178500000,178600000,178700000,178800000,178900000,179000000,179100000,179200000,179300000,179400000,179500000,179600000,179700000,179800000,179900000,180000000,180100000,180200000,180300000,180400000,180500000,180600000,180700000,180800000,180900000,181000000,181100000,181200000,181300000,181400000,181500000,181600000,181700000,181800000,181900000,182000000,182100000,182200000,182300000,182400000,182500000,182600000,182700000,182800000,182900000,183000000,183100000,183200000,183300000,183400000,183500000,183600000,183700000,183800000,183900000,184000000,184100000,184200000,184300000,184400000,184500000,184600000,184700000,184800000,184900000,185000000,185100000,185200000,185300000,185400000,185500000,185600000,185700000,185800000,185900000,186000000,186100000,186200000,186300000,186400000,186500000,186600000,186700000,186800000,186900000,187000000,187100000,187200000,187300000,187400000,187500000,187600000,187700000,187800000,187900000,188000000,188100000,188200000,188300000,188400000,188500000,188600000,188700000,188800000,188900000,189000000,189100000,189200000,189300000,189400000,189500000,189600000,189700000,189800000,189900000,190000000,190100000,190200000,190300000,190400000,190500000,190600000,190700000,190800000,190900000,191000000,191100000,191200000,191300000,191400000,191500000,191600000,191700000,191800000,191900000,192000000,192100000,192200000,192300000,192400000,192500000,192600000,192700000,192800000,192900000,193000000,193100000,193200000,193300000,193400000,193500000,193600000,193700000,193800000,193900000,194000000,194100000,194200000,194300000,194400000,194500000,194600000,194700000,194800000,194900000,195000000,195100000,195200000,195300000,195400000,195500000,195600000,195700000,195800000,195900000,196000000,196100000,196200000,196300000,196400000,196500000,196600000,196700000,196800000,196900000,197000000,197100000,197200000,197300000,197400000,197500000,197600000,197700000,197800000,197900000,198000000,198100000,198200000,198300000,198400000,198500000,198600000,198700000,198800000,198900000,199000000,199100000,199200000,199300000,199400000,199500000,199600000,199700000,199800000,199900000,200000000
    ]
  };
};

const state = getDefaultState();

const getters = {};

const mutations = {
  addChildObj(state, count) {
    //Set default child DOB
    let d = new Date();
    d.setFullYear(d.getFullYear() - 1);

    //if the children have not been selected before
    if (state.familyInfoData.rdbChildrenPrev == "New") {
      state.childInfoData = [];

      //add to child information
      let length = 1;
      while (length <= count) {
        state.childInfoData.push({
          title: "",
          first_name: "",
          middle_name: "",
          last_name: "",
          gender: "Male",
          dob: d.toJSON().slice(0, 10),
          age: 1
        });
        length++;
      }

      //setting the current selected value to the previous value
      state.familyInfoData.rdbChildrenPrev = Number(
        state.familyInfoData.rdbChildren
      );
    }
    //when we need to add more items from the existing array
    else if (count > state.familyInfoData.rdbChildrenPrev) {
      let diff = count - state.familyInfoData.rdbChildrenPrev;

      let length = 1;
      while (length <= diff) {
        state.childInfoData.push({
          title: "",
          first_name: "",
          middle_name: "",
          last_name: "",
          gender: "Male",
          dob: d.toJSON().slice(0, 10),
          age: 1
        });
        length++;
      }

      //setting the current selected value to the previous value
      state.familyInfoData.rdbChildrenPrev = Number(
        state.familyInfoData.rdbChildren
      );
    }
    //when we need to remove items from the existing array
    else if (state.familyInfoData.rdbChildrenPrev > count) {
      let diff = state.familyInfoData.rdbChildrenPrev - count;

      //removing items from the last position
      for (let i = 0; i < diff; i++) {
        state.childInfoData.pop();
      }


      //setting the current selected value to the previous value
      state.familyInfoData.rdbChildrenPrev = Number(
        state.familyInfoData.rdbChildren
      );
    }
  },
  updateQuotationList(state, data) {
    state.quotationList = data.data;
  },
  //** Rider response map to state objet  */
  setRidersObj(state, data) {
    //** Main life riders  */
    state.riderDataMain = data.main;
    //** Spouse riders  */
    state.riderDataSpouse = data.spouse;
    //** Children riders  */
    state.riderDataChildren = data.children;
    //** Timestamp for DOB calander current date  */
    state.timestamp = data.timestamp.substring(0, 10);
  },
  setAgeObj(state, { data, type, index }) {
    if (type == "main") {
      state.mainInfoData.txtMainLifeAge = data.age;
    } else if (type == "spouse") {
      state.spouseInfoData.txtSpouseAge = data.age;
    } else if (type == "child") {
      state.childInfoData[index].age = data.age;
    }
    if(data.timestamp){
      state.timestamp = data.timestamp.substring(0, 10);
    }
  },
  setOccupationObj(state, data) {
    //** Set Occupation list   */
    state.occupationList = data.occupations;
  },
  setHospitalObj(state, data) {
    //** Set hospital list   */
    state.hospitalList = data;
    //console.log(data);
  },
  setOccupationLoadingObj(state, data) {
    //** Set Occupation list   */
    state.occupationLoadingList = data;
    //console.log(data);
  },
  //** Create Illustration response map to state object  */
  setChangedObj(state, data) {
    state.calcSummary = data;
    //console.log(data);
  },
  clearObj(state) {
    Object.assign(state, getDefaultState());
  },
  loadQuotationData(state, data) {
    /** main mamber  */
    state.mainInfoData.txtMainLifeFname = data.member_main.first_name;
    state.mainInfoData.drpMainLifetitle = data.member_main.title;
    state.mainInfoData.txtMainLifeFname = data.member_main.first_name;
    state.mainInfoData.txtMainLifeMname = data.member_main.middle_name;
    state.mainInfoData.txtMainLifeLname = data.member_main.last_name;
    state.mainInfoData.txtMainLifeNIC = data.member_main.nic;
    state.mainInfoData.txtMainLifeEmail = data.member_main.email;
    state.mainInfoData.txtMainLifeMob = data.member_main.telephone;
    state.mainInfoData.rdbMainGender = data.member_main.gender;
    state.mainInfoData.txtMainLifeDOB = data.member_main.dob;
    state.mainInfoData.drpMainLifeOccupation = data.member_main.occupation;
    state.mainInfoData.txtMainLifeSumCover = data.additional_info.life_cover;

    state.mainInfoData.drpMainLifePrimaryNeed =
      data.additional_info.primary_need;
    state.mainInfoData.rdbMainLifeFrequency =
      data.additional_info.frequency == "Y"
        ? "A"
        : data.additional_info.frequency;
    state.mainInfoData.txtMainLifeMonthlyBasicPrem =
      data.additional_info.monthly_basic_premium;
    state.mainInfoData.txtMainLifePremiumTerm =
      data.additional_info.premium_term;
    state.mainInfoData.txtMainLifePolicyTerm = data.additional_info.policy_term;
    state.mainInfoData.drpMainLifeContributionTerm = data.additional_info.contribution_term;
    state.mainInfoData.drpMainLifeCoverMultiple = data.additional_info.covermultiple;
    state.mainInfoData.txtMainSumAtRisk =
      data.member_main.sum_at_risk_prev_policy;
    (state.mainInfoData.txtNumOfSumAsTimes =
      data.member_main.no_of_sum_ass_times),
        state.mainInfoData.rdbMainMedrem3Floater = data.additional_info.med_rem3_floater;
        
      /** main mamber riders */
      (state.riderDataMain = data.member_main.riders);
    /** family info panel */
    state.familyInfoData.drpFamilyInfoMaritalStatus =
      data.member_main.marital_status;
    state.familyInfoData.rdbSpouse = data.member_main.has_spouse;
    state.familyInfoData.rdbChildren = Number(data.member_main.children);
    /** spouse info */
    state.spouseInfoData.drpSpouseTitle = data.member_spouse.title;
    state.spouseInfoData.txtSpouseFname = data.member_spouse.first_name;
    state.spouseInfoData.txtSpouseMname = data.member_spouse.middle_name;
    state.spouseInfoData.txtSpouseLname = data.member_spouse.last_name;
    state.spouseInfoData.rdbSpouseGender = data.member_spouse.gender;
    state.spouseInfoData.txtSpouseDOB = data.member_spouse.dob;
    state.spouseInfoData.drpSpouseOccupation = (data.member_spouse.occupation != undefined ? data.member_spouse.occupation : state.spouseInfoData.drpSpouseOccupation);
    state.spouseInfoData.txtSpouseSumAtRisk =
      data.member_spouse.sum_at_risk_prev_policy;
    /** spouse member riders */
    state.riderDataSpouse = data.member_spouse.riders;
    /** child mamber info */
    state.childInfoData = data.member_child;

    state.riderDataChildren = data.child_riders;

    //will be used in addChildObj mutation
    state.familyInfoData.rdbChildrenPrev = state.familyInfoData.rdbChildren;

    /** child mamber riders */

    /** Quotation no and version no for updated purposes */
    state.quotationNo = data.quote_no;
    state.version = data.version;
    state.refNo = data.ref_no;
  },
  /** Error Message setter */
  setError(state, { error, errorType }) {
    //console.log("called set error " + errorType);
    //console.log("called set error " + error);
    state.flash = {
      type: errorType,
      status: true,
      error: error
    };
    //console.log(state.flash.status);
  },
  /** Error Message destroy */
  clearFlash(state) {
    state.flash = {
      type: "",
      status: false,
      error: ""
    };
  },

  /** Minified Summary Message setter */
  setMinMsg(state, data) {
    state.minflash = {
      status: true,
      error: data
    };
    //console.log(state.flash.status);
  },
  /** Minified Summary Message destroy */
  clearMinMsg(state) {
    state.minflash = {
      status: false,
      error: ""
    };
  },

  setChangedObjSuccessCreate(state) {
    state.flash.status = true;
  }
};
const actions = {
  async clearStateData({ commit }) {
    commit("clearObj");
  },
  async addChild({ commit }, count) {
    commit("addChildObj", count);
  },
  async addChangedData({ commit, state }, type = "preview", refno = null) {
    console.log(type);
    let member_main = {};
    let member_spouse = {};
    let member_child = {};
    let child_riders = {};
    let additional_info = {};

    if (type == "update") {
      refno = state.refNo;
    }

    let data = {
      save_state: type,
      branch_code: "CLS",
      channel_code: "01",
      user_category: "MDRT",
      agent_code: "E660",
      user_role: "UWR",
      ref_no: refno
    };
    if (state.mainInfoData.rdbMainLifeFrequency == "S") {
      state.mainInfoData.txtNumOfSumAsTimes = 0;
    }
    /** Member information hold object */
    member_main = {
      title: state.mainInfoData.drpMainLifetitle,
      first_name: state.mainInfoData.txtMainLifeFname,
      middle_name: state.mainInfoData.txtMainLifeMname,
      last_name: state.mainInfoData.txtMainLifeLname,
      nic: state.mainInfoData.txtMainLifeNIC,
      email: state.mainInfoData.txtMainLifeEmail,
      gender: state.mainInfoData.rdbMainGender,
      dob: state.mainInfoData.txtMainLifeDOB,
      telephone: state.mainInfoData.txtMainLifeMob,
      occupation: state.mainInfoData.drpMainLifeOccupation,
      marital_status: state.familyInfoData.drpFamilyInfoMaritalStatus,
      has_spouse: state.familyInfoData.rdbSpouse,
      children: Number(state.familyInfoData.rdbChildren),
      sum_at_risk_prev_policy: state.mainInfoData.txtMainSumAtRisk,
      no_of_sum_ass_times: state.mainInfoData.txtNumOfSumAsTimes,
      riders: state.riderDataMain
    };

    (additional_info = {
      primary_need: state.mainInfoData.drpMainLifePrimaryNeed,
      monthly_basic_premium: state.mainInfoData.txtMainLifeMonthlyBasicPrem,
      life_cover: state.mainInfoData.txtMainLifeSumCover,
      premium_term: state.mainInfoData.txtMainLifePremiumTerm,
      policy_term: state.mainInfoData.txtMainLifePolicyTerm,
      contribution_term: state.mainInfoData.drpMainLifeContributionTerm,
      frequency:
        state.mainInfoData.rdbMainLifeFrequency == "A"
          ? "Y"
          : state.mainInfoData.rdbMainLifeFrequency,
        covermultiple: state.mainInfoData.drpMainLifeCoverMultiple,
        med_rem3_floater: state.mainInfoData.rdbMainMedrem3Floater,
    }),
      /** Spouse information hold object */
      (member_spouse = {
        title: state.spouseInfoData.drpSpouseTitle,
        first_name: state.spouseInfoData.txtSpouseFname,
        middle_name: state.spouseInfoData.txtSpouseMname,
        last_name: state.spouseInfoData.txtSpouseLname,
        gender: state.spouseInfoData.rdbSpouseGender,
        dob: state.spouseInfoData.txtSpouseDOB,
        occupation: state.spouseInfoData.drpSpouseOccupation,
        sum_at_risk_prev_policy: state.spouseInfoData.txtSpouseSumAtRisk,
        riders: state.riderDataSpouse
      });

    member_child = state.childInfoData;
    child_riders = state.riderDataChildren;

    //** Illustration request object prepare */
    data = {
      ...data,
      member_main,
      member_spouse,
      additional_info,
      member_child,
      child_riders
    };
    let errorType = "";
    let error = "";
    //** Illustration request axios call */
    commit("clearFlash"); //destroy snotify
    commit("clearMinMsg"); // destroy Min Summary Message
    await http
      .post("quote_term_plus_cic/illustration", { data }, {})
      .then(response => {
        if (response.data.meta.status == "true") {
          if (type == "create" || type == "update") {
            //commit("setChangedObjSuccessCreate");
            error = response.data.meta.status_message;
            errorType = "S";
            //console.log("illustration response :" + error);
            commit("setError", { error, errorType });
          } else {
            commit("setChangedObj", response.data.data);
            commit(
              "setMinMsg",
              " Rs. " + response.data.data.summary_formatted.total_premium
            );
            commit("common_actions/setShaking" , null, { root: true });
          }
        } else {
          error = response.data.meta.status_message;
          errorType = "E";
          //console.log("illustration response :" + error);
          commit("setError", { error, errorType });
        }
      })
      .catch(error => {
        let errorType = "E";
        //commit("setError", "Error : illustration Service Response Failed");
        //alert("Error : illustration Service Response Failed");
        commit("setError", { error, errorType });
      });
  },
  async getRidersList({ commit }) {
    let errorType = "";
    //** Riders list(Main Life, Spouse, Children) request axios call  */
    commit("clearFlash"); //destroy snotify
    await http
      .post("quote_term_plus_cic/riders", { product: "product_one" }, {})
      .then(response => {
        if (response.data.meta.status == "true") {
          commit("setRidersObj", response.data.data);
        } else {
          errorType = "E";
          let error = "Error : Rider Service Response Failed";
          commit("setError", { error, errorType });
          //alert("Error : Rider Service Response Failed");
        }
      })
      .catch(error => {
        //alert(error);
        errorType = "E";
        commit("setError", { error, errorType });
      });
  },
  async getOccupationList({ commit }) {
    //** Occupation list request axios call  */
    commit("clearFlash"); //destroy snotify
    await http
      .post("quote/occupation_list", null, {})
      .then(response => {
        if (response.data.meta.status == "true") {
          commit("setOccupationObj", response.data.data);
        } else {
          let errorType = "E";
          let error = "Error : Occupation Service Response Failed";
          commit("setError", { error, errorType });
          //alert("Error : Occupation Service Response Failed");
        }
      })
      .catch(error => {
        //alert(error);
        let errorType = "E";
        commit("setError", { error, errorType });
      });
  },
  async getHospitalList({ commit }) {
    let errorType = "E";
    //** Hospital list request axios call  */
    commit("clearFlash"); //destroy snotify
    await http
      .post("conf/hospitals", null, {})
      .then(response => {
        if (response.data.meta.status == "true") {
          //console.log(response.data.data[0]);
          commit("setHospitalObj", response.data.data);
        } else {
          errorType = "E";
          let error = "Error : Hospital Service Response Failed";
          commit("setError", error, errorType);
        }
      })
      .catch(error => {
        //alert(error);
        errorType = "E";
        commit("setError", { error, errorType });
      });
  },
  async getAge({ commit }, payload) {
    let dob = payload.dob;
    let errorType = "";
    //** Age Calculation axios call  */
    commit("clearFlash"); //destroy snotify
    await http
      .post("quote/get_age", { dob: dob }, {})
      .then(response => {
        if (response.data.meta.status == "true") {
          let data = response.data.data;
          let type = payload.type;

          //this is to be used to identify the child
          let index = 0;
          if (payload.hasOwnProperty("index")) {
            index = payload.index;
          }
          commit("setAgeObj", { data, type, index });
        } else {
          errorType = "E";
          let error =
            "Error : Main Life Age Calculator Service Response Failed";
          commit("setError", error, errorType);
          //alert("Error : Main Life Age Calculator Service Response Failed");
        }
      })
      .catch(error => {
        //alert(error);
        errorType = "E";
        commit("setError", { error, errorType });
      });
  },
  async getQuotationList({ commit }, filterText) {
    let errorType = "";
    commit("clearFlash"); //destroy snotify
    await http
      .post("quote/list", filterText, {})
      .then(response => {
        if (response.data.meta.status == "true") {
          commit("updateQuotationList", response.data.data);
        } else {
          errorType = "E";
          let error = "Error : Get Quotation List Service Response Failed";
          commit("setError", { error, errorType });
          //alert("Something went wrong - getQuotationList");
        }
      })
      .catch(error => {
        //alert(error);
        errorType = "E";
        commit("setError", { error, errorType });
      });
  },
  async getOneQuotation({ commit }, refNo) {
    let errorType = "";
    commit("clearFlash"); //destroy snotify
    await http
      .post("quote_term_plus_cic/view", { ref_no: refNo }, {})
      .then(response => {
        if (response.data.meta.status == "true") {
          //console.log(response.data.data);
          commit("loadQuotationData", response.data.data);
        } else {
          errorType = "E";
          let error = "Error : Get One Quotation Service Response Failed";
          commit("setError", { error, errorType });
          //alert("Something went wrong - getOneQuotation");
        }
      })
      .catch(error => {
        //alert(error);
        errorType = "E";
        commit("setError", { error, errorType });
      });
  },
  async getRequestLetter({ commit }, payload) {
    let errorType = "E";
    let hospital = payload.hospital.code;
    let parties = payload.parties;
      let quoteNo = payload.quote_no;
    await http
        .post("quote/medical_letter",
            {
              hospital: hospital,
                parties: parties,
                quote_no: quoteNo
            }, {})
        .then(response => {
          if (response.data.meta.status == "true") {
              //console.log(response.data.data);
              if (response.data.data) {
                return response.data.data;
                  /*window.open(
                      response.data.data,
                      '_blank' // <- This is what makes it open in a new window.
                  );
                  */
              }
          } else {
            errorType = "E";
            let error = "Error : Get One Request Letter Response Failed";
            commit("setError", {error, errorType});
          }
        })
        .catch(error => {
          errorType = "E";
          commit("setError", {error, errorType});
        });
  },
  async getOccupationLoading({commit}, payload) {
    let errorType = "E";
    let quoteNo = payload.quote_no;
    await http
        .post("quote/occ_loading",
            {
              quote_no: quoteNo
            }, {})
        .then(response => {
          if (response.data.meta.status == "true") {
            //console.log(response.data.data);
            commit("setOccupationLoadingObj", response.data.data);
          } else {
            errorType = "E";
            let error = "Error : Get Occupation Loading Request Letter Response Failed";
            commit("setError", {error, errorType});
          }
        })
        .catch(error => {
          errorType = "E";
          commit("setError", {error, errorType});
        });
  },
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
